<template>
<div id="apptable" v-cloak>

    <b-card :header="'Orari ' + getDescTipo(this.tipo).toLowerCase() + ' #' + id" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
        <div class="text-left">

            <div class="my-1 row">
                <div class="col-md-3">
                    <b-form-input v-model="filter" placeholder="Cerca..." />
                </div>
                <div class="col-md-9 text-right">
                    <b-button style="margin:1px 0px 1px 2px;" size="md" variant="outline-primary" @click.stop="insert()">
                        Inserisci
                    </b-button>
                </div>
            </div>

            <!-- Main table element -->
            <b-table responsive v-show="showtable" id="main-table" striped hover show-empty :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @filtered="onFiltered" empty-text="Non sono stati trovati record da visualizzare" empty-filtered-text="Non sono stati trovati record corrispondenti alla tua richiesta">
                <template slot="id" scope="row">{{row.value}}</template>
                        <template slot="id" scope="row">{{row.value}}</template>
                        <template slot="giorno" scope="row">{{row.value}}</template>
                        <template slot="orainizio" scope="row">{{row.value}}</template>
                        <template slot="orafine" scope="row">{{row.value}}</template>
                        <template slot="datainizio" scope="row">{{row.value | formatDate}}</template>
                        <template slot="datafine" scope="row">{{row.value | formatDate}}</template>                        
                        <template slot="prenotabilitàVis" scope="row">{{row.value}}</template>
                        <template slot="stato" scope="row">{{row.value}}</template>

                        <template slot="modifica" scope="row">
                            <!-- We use click.stop here to prevent a 'row-clicked' event from also happening -->
                            <b-btn style="margin:0px 0px 1px 2px;" variant="warning" size="sm" @click.stop="del(row.item,row.index,$event.target)">Elimina</b-btn>
                            <!-- <b-btn style="margin:0px 0px 1px 2px;" v-if="tipoevento == 'D'" size="sm" @click.stop="details(row.item,row.index,$event.target)">Modifica</b-btn>   -->
                            <b-btn style="margin:0px 0px 1px 2px;" size="sm" @click.stop="details(row.item,row.index,$event.target)">Modifica</b-btn>  
                            <b-btn style="margin:0px 0px 1px 2px;" size="sm" @click.stop="duplica(row.item,row.index,$event.target)">Duplica</b-btn>                       
                        </template>

            </b-table>

            <div class="row my-1">
                <div class="col-md-8 col-sm-12">
                    <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
                </div>
                <div class="col-md-4 col-sm-12 text-right">
                    <b-form-fieldset horizontal label="Righe per pagina" :label-cols="6">
                        <b-form-select :options="pageOptions" v-model="perPage" />
                    </b-form-fieldset>
                </div>
            </div>
        </div>

        <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>

    </b-card>

    <!-- Modal Component -->
    <b-modal v-model="deleteModal.show" title="Elimina">
        <p class="my-2">Confermi l'eliminazione dell'orario #{{deleteModal.id}}?</p>
        <div slot="modal-footer" class="w-100">
            <b-btn size="sm" class="float-right" variant="primary" @click="delItem()" style="margin: 2px;">
                Conferma
            </b-btn>
            <b-btn size="sm" class="float-right" variant="secondary" @click="deleteModal.show=false" style="margin: 2px;">
                Annulla
            </b-btn>
        </div>
    </b-modal>
    
</div>
</template>

<script>
import moment from 'moment'

import {
    NAMESPACE
} from '../config.js'

import {
    ctrlVismenu
} from '../util.js'

import {
    Partecipa,
    Categoria,
    Prenotabilità,
    Orario
} from '../classes.js'

export default {
    name: 'apptable',
    data: function () {
        return {      
            id: this.$route.params.id,
            tipo: this.$route.params.tipo,            
            items: [],
            namespace: NAMESPACE,
            parametri: null,
            fields: {
                id: {
                    label: '#',
                    sortable: true
                },
                giorno: {
                    label: 'Giorno',
                    sortable: true
                },
                orainizio: {
                    label: 'Ora inizio',
                    sortable: true
                },
                orafine: {
                    label: 'Ora fine',
                    sortable: true
                },
                datainizio: {
                    label: 'Data inizio',
                    sortable: true
                },
                datafine: {
                    label: 'Data fine',
                    sortable: true
                },                
                prenotabilitàVis: {
                    label: 'Prenotabilita',
                    sortable: true
                },                
                stato: {
                    label: 'Stato',
                    sortable: true
                },
                modifica: {
                    label: ' ',
                    'class': 'text-right'
                }
            },
            deleteModal: {
                id: null,
                show: false
            },
            currentPage: 1,
            perPage: 10,
            pageOptions: [{
                text: 10,
                value: 10
            }, {
                text: 25,
                value: 25
            }, {
                text: 50,
                value: 50
            }],
            sortBy: null,
            sortDesc: false,
            filter: null,
            totalRowsFilter: null,
            modalDetails: {
                index: '',
                data: ''
            },
            error: '',
            showerror: false,
            showtable: false
        };
    },
    computed: {
        totalRows: {
            // getter
            get: function () {
                return this.totalRowsFilter || this.items.length || 0;
            },
            // setter
            set: function (newValue) {
                this.totalRowsFilter = newValue;
            }
        }, 
    },
    methods: {        
        insert() {
            this.$router.push('/app/dettaglioorario/id_scheda/' + this.id + '/tipo/' + this.tipo);
        },
        details(item, index, button) {
            this.$router.push({
                path: `/app/dettaglioorario/${item.id}`
            });
        },
        duplica(item, index, button) {
            this.$router.push({
                path: `/app/dettaglioorario/${item.id}/duplica/true`
            });
        },
        del(item, index, button) {
            this.deleteModal.id = item.id;
            this.deleteModal.show = true;
        },
        delItem() {

            var token = localStorage.getItem('token');
            this.axios.delete(NAMESPACE + 'rest/orari/' + this.deleteModal.id, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            //forse può essere fatta diversamente e meglio
                            for (var i = 0; i < this.items.length; i++) {
                                if (this.items[i].id == this.deleteModal.id) {
                                    this.items.splice(i, 1); //delete
                                    break;
                                }
                            }
                            this.deleteModal.show = false;


                        } else {
                            throw new Error(response.data.message);
                        }


                    } catch (e) {

                        this.deleteModal.show = false;
                        this.showerror = true;
                        this.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {

                    this.deleteModal.show = false;
                    this.showerror = true;
                    this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        getDescTipo(tipo) {
            var cat = new Categoria();
            return cat.getTipoByFlag(tipo);
        },       
        getDescPrenotabilità(value){

            var prenotabilità = new Prenotabilità();
            let res = prenotabilità.getTipoByFlag(value); 
            
            if(this.parametri != null && this.parametri.labelorarinessuno != ''){

                if(res == "Nessuno"){
                    res = this.parametri.labelorarinessuno;
                }                                             

            }

            return res;

        }
    },
    filters: {
        formatDate: function(value) {
            if (!value) return '';
            return moment(String(value)).format('DD/MM/YYYY');
        }
    },
    created: function () {

        if(!ctrlVismenu("I")){
            this.$router.replace('/accessdenied');
            return;
        }

        var token = localStorage.getItem('token');
        this.axios.get(NAMESPACE + 'rest/orari/id_scheda/' + this.id + '/tipo/' + this.tipo, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then(response => {
                // JSON responses are automatically parsed.
                try {

                    if (!response.data.error) {

                        if (response.data.token != null) localStorage.setItem('token', response.data.token);

                        this.items = response.data.message;
                        let apptable = this;
                        
                        //console.log("Res orari");
                        
                        apptable.items.forEach(function(element, index) {
                            element.stato = (element.flagsta == 'S' ? 'Attivo' : 'Annullato');
                            //var prenotabilità = new Prenotabilità();
                            element.prenotabilitàVis = apptable.getDescPrenotabilità(element.prenotabilita); //prenotabilità.getTipoByFlag(element.prenotabilita);  
                            var orario = new Orario();
                            element.giorno = orario.getGiornoSettimanaByNumero(element.giorno); 
                        });

                        this.showtable = true;

                    } else {
                        throw new Error(response.data.message);
                    }

                } catch (e) {
                    this.showerror = true;
                    this.error = "Errore: " + e.message;
                }

            })
            .catch(e => {
                this.showerror = true;
                this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
            });


            var appdettaglio = this;
            token = localStorage.getItem('token');

            //PAREMETRI
            this.axios.get(NAMESPACE + 'rest/cral', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then(response => {
                // JSON responses are automatically parsed.
                try {

                    if (!response.data.error) {

                        if (response.data.token != null) localStorage.setItem('token', response.data.token);

                        var res = response.data.message;
                        //alert("Ret: " + JSON.stringify(res))
                        if (typeof res == "object") {

                            appdettaglio.parametri = res;
                            //console.log("Res par");
                            appdettaglio.items.forEach(function(element, index) {
                                element.prenotabilitàVis = appdettaglio.getDescPrenotabilità(element.prenotabilita);
                            });
                            //forza l'update della view
                            appdettaglio.$forceUpdate();

                        } else {
                            throw new Error("Errore parametri non trovati!");
                        }


                    } else {
                        throw new Error(response.data.message);
                    }


                } catch (e) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Errore: " + e.message;
                }

            })
            .catch(e => {
                appdettaglio.showerror = true;
                appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
            });

    }
}
</script>
